function FailureAlertIconSimple() {
  return (
    <svg width="16" height="16" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="10" cy="10" r="9" stroke="var(--error-500)" strokeWidth="2" fill="none" />
      <path
        d="M10 6V10M10 13H10.01"
        stroke="var(--error-500)"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default FailureAlertIconSimple
